import { NavLink } from 'react-router-dom'
import { BrandLogo } from './BrandLogo'
import { NAV_ICONS } from './NavIcons'
import { NAV_ITEMS } from '../constants/navigation'
import { APP_ROUTES } from '../constants/routes'
import { useAuth } from '../hooks/useAuth'
import { cx } from '../helpers/format'
import '../styles/sidebar.scss'

export function Sidebar() {
  const { user, logout } = useAuth()

  return (
    <aside className="sidebar">
      <div className="sidebar__brand">
        <BrandLogo />
      </div>
      <nav className="sidebar__nav" aria-label="Primary">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === APP_ROUTES.home}
            className={({ isActive }) =>
              cx('sidebar__link', isActive && 'sidebar__link--active')
            }
          >
            <span className="sidebar__icon" aria-hidden>
              {NAV_ICONS[item.icon]}
            </span>
            <span className="sidebar__label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="sidebar__footer">
        <p className="sidebar__user" title={user?.email ?? undefined}>
          {user?.name || user?.email || 'Vendor'}
        </p>
        <button
          type="button"
          className="btn btn--outline sidebar__logout"
          onClick={() => {
            void logout()
          }}
        >
          Sign out
        </button>
      </div>
    </aside>
  )
}
